import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页' }
      },
      // 超级管理员路由
      {
        path: 'admin-manage',
        name: 'AdminManage',
        component: () => import('@/views/super/AdminManage.vue'),
        meta: { title: '管理员管理', roles: ['SUPER_ADMIN'] }
      },
      // 管理员路由
      {
        path: 'mailbox-manage',
        name: 'MailboxManage',
        component: () => import('@/views/admin/MailboxManage.vue'),
        meta: { title: '子邮箱管理', roles: ['ADMIN', 'SUPER_ADMIN'] }
      },
      {
        path: 'sub-emails',
        name: 'SubEmails',
        component: () => import('@/views/admin/SubEmails.vue'),
        meta: { title: '子邮箱邮件查看', roles: ['ADMIN', 'SUPER_ADMIN'] }
      },
      // 子邮箱用户路由
      {
        path: 'inbox',
        name: 'Inbox',
        component: () => import('@/views/mail/Inbox.vue'),
        meta: { title: '收件箱', roles: ['USER'] }
      },
      {
        path: 'sent',
        name: 'Sent',
        component: () => import('@/views/mail/Sent.vue'),
        meta: { title: '已发送', roles: ['USER'] }
      },
      {
        path: 'draft',
        name: 'Draft',
        component: () => import('@/views/mail/Draft.vue'),
        meta: { title: '草稿箱', roles: ['USER'] }
      },
      {
        path: 'compose',
        name: 'Compose',
        component: () => import('@/views/mail/Compose.vue'),
        meta: { title: '写邮件', roles: ['USER'] }
      },
      {
        path: 'mail-detail/:id',
        name: 'MailDetail',
        component: () => import('@/views/mail/MailDetail.vue'),
        meta: { title: '邮件详情' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  if (!store.getters.isLoggedIn) {
    next('/login')
    return
  }
  // 角色权限检查
  if (to.meta && to.meta.roles) {
    const userRole = store.getters.role
    if (!to.meta.roles.includes(userRole)) {
      next('/dashboard')
      return
    }
  }
  next()
})

export default router
